import { createRouter, createWebHistory } from 'vue-router'
import store from "@/store";
import Cookies from "js-cookie";
import HomeView from '../views/HomeView.vue'

const routes = [
  {
    path: "/",
    name: "home",
    component: HomeView,
    meta: { title: " الرئيسيه", requiresAuth: false },
  },
  {
    path: '/login' ,
    name: 'login' ,
    component: () => import('@/views/Auth/LoginView.vue') ,
    meta:{
      title: 'تسجيل الدخول' , 
      requiresAuth: false
    }
  },
  {
    path: '/register' ,
    name: 'register' ,
    component: () => import('@/views/Auth/RegisterView.vue') ,
    meta:{
      title: 'انشاء حساب جدبد' , 
      requiresAuth: false
    }
  },
  {
    path: '/privacy-policy' ,
    name: 'privacy-policy' ,
    component: () => import('@/views/TermsConditions/PrivacyPolicyView.vue') ,
    meta:{
      title: 'سياسه الخصوصيه' , 
      requiresAuth: false
    }
  },
  {
    path: '/refund-policy' ,
    name: 'refund-policy' ,
    component: () => import('@/views/TermsConditions/RefundPolicyView.vue') ,
    meta:{
      title: 'سياسه الاسترجاع' , 
      requiresAuth: false
    }
  },
  {
    path: '/terms-conditions' ,
    name: 'terms-conditions' ,
    component: () => import('@/views/TermsConditions/TermsConditionsView.vue') ,
    meta:{
      title: 'البنود والشروط' , 
      requiresAuth: false
    }
  },
  {
    path: '/our-products' ,
    name: 'products_all' ,
    component: () => import('@/views/ProductsView.vue') ,
    meta:{
      title: 'جميع المنتجات' , 
      requiresAuth: false
    }
  },
  {
    path: '/size-instructions' ,
    name: 'size_instructions' ,
    component: () => import('@/views/SizedInstructionsView.vue') ,
    meta:{
      title: 'دليل المقاسات' , 
      requiresAuth: false
    }
  },
  {
    path: '/product-details/:product_id' ,
    name: 'product-details' ,
    props: true,
    component: () => import('@/views/ProductDetailsView.vue') ,
    meta:{
      title: 'تفاصيل المنتجات' , 
      requiresAuth: false
    }
  },
  {
    path: '/add-pill-address/:pill_id' ,
    name: 'add_pill_address' ,
    props: true,
    component: () => import('@/views/AddPillAddress.vue') ,
    meta:{
      title: 'اضافه عنوان للطلب' , 
      requiresAuth: true
    }
  },
  {
    path: '/cart' ,
    name: 'cart' ,
    props: true,
    component: () => import('@/views/CartView.vue') ,
    meta:{
      title: 'عربه التسوق' , 
      requiresAuth: true
    }
  },
  {
    path: '/user-profile' ,
    name: 'profile' ,
    props: true,
    component: () => import('@/views/Profile/ProfileLayout.vue') ,
    meta:{
      requiresAuth: true
    },
    children:[
      {
        path: '' ,
        name: 'profile_data' ,
        component: () => import('@/views/Profile/UserProfileView.vue'),
        meta:{
          title: 'ملف المستخدم' , 
        }
      },
      {
        path: 'user-orders' ,
        name: 'profile_orders' ,
        component: () => import('@/views/Profile/UserOrdersView.vue'),
        meta:{
          title: 'اوردراتي' , 
        }
      },
    ]
  },
  
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

router.beforeEach((to, from, next) => {
  document.body.scrollTop = 0; // For Safari
  document.documentElement.scrollTop = 0; // For Chrome, Firefox, IE and Opera
  
  const token = Cookies.get("user_token")
    if (token) {
      store.commit("LOGIN_USER", token);
    }

  const isAuthenticated = store.state.isAuthenticated;

  // Set document title from route meta, default to 'App' if no title is set
  document.title = to.meta.title || "not found";

  // if user try to access login and register routes and user is auth
  if (to.matched.some((record) => record.meta.requiresAuth)) {
    if (isAuthenticated) {
      next();
    } else {
      next({ name: "login" });
    }
  } else {
    next();
  }
});

export default router
